import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { SETTINGS_INJECTION_TOKENS } from '@tourfold/shared-kernels/settings-registry';
import { BillingSettings } from './settings-billing.component';
import { ResourceAccessGuard } from '@tourfold/shared-kernels/resource-access';

export function provideSettingsElementBilling(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: SETTINGS_INJECTION_TOKENS,
      useValue: {
        path: 'billing',
        name: 'Billing',
        icon: 'pi pi-credit-card',
        component: BillingSettings,
        order: 0,
        translateName: 'SETTINGS_BILLING.TITLE',
        resource_key: 'billing',
        required_action: 'read',
        canActivate: [ResourceAccessGuard],
        category: {
          id: 'other',
          name: 'Other',
          order: 3,
          translateName: 'SETTINGS.CATEGORIES.OTHER',
        },
      },
      multi: true,
    },
  ]);
}
